import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { IM_FLAGS } from '~/impact-measurement/constants';
import { useSplit } from '~/impact-measurement/hooks';
import {
  getMeasurementRedirectUrl,
  handleKeepOldUiQueryParam,
  shouldKeepOldUi
} from '~/utils/measurementRedirect';

export const MeasurementUiRedirect = () => {
  const location = useLocation();
  const { isOn: isWelcomeOn } = useSplit(IM_FLAGS.FF_WELCOME);

  useEffect(() => {
    handleKeepOldUiQueryParam(location.search);
  }, [location.search]);

  useEffect(() => {
    if (!isWelcomeOn || shouldKeepOldUi()) {
      return;
    }

    const redirectUrl = getMeasurementRedirectUrl(window.location.pathname);

    if (redirectUrl) {
      window.location.assign(redirectUrl);
    }
  }, [location.pathname, isWelcomeOn]);

  return null;
};
